import {
    PLANT,
    SOIL_MIXING
} from '../consts/product/Types';

export default productType => [PLANT, SOIL_MIXING].indexOf(productType) !== -1 ? 120 : 100;